// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"842b84e3","515":"da7e8c15","543":"24ff317f","637":"e729aff1","744":"b50cba86"}[chunkId] + ".chunk.js";
};